import type { FC } from 'react';

interface RawDisplayProps {
  data: any;
}

export const RawDisplay: FC<RawDisplayProps> = ({ data }) => {
  // Create a copy of the data to modify for display
  let displayData = { ...data };
  
  // Check if imageUrl exists and is a data URL (from an uploaded image)
  if (displayData && displayData.imageUrl && typeof displayData.imageUrl === 'string' && 
      displayData.imageUrl.startsWith('data:')) {
    // Replace the data URL with a placeholder to avoid displaying a very long string
    displayData.imageUrl = '[Custom Image Data - Hidden for Readability]';
  }
  
  const content = typeof displayData === 'string' ? displayData : JSON.stringify(displayData, null, 2);

  return (
    <div className="max-w-md mx-auto px-4 my-6">
      <div className="bg-gray-100 rounded-xl shadow-inner overflow-hidden">
        <h2 className="text-xl font-bold text-center p-4 bg-gray-200">Raw API Response</h2>
        <pre className="p-6 text-xs text-gray-700 whitespace-pre-wrap break-words">
          {content}
        </pre>
      </div>
    </div>
  );
};

export default RawDisplay;
